import React from 'react';
import DirectorsContainer from './styles';
import { useTranslation } from 'react-i18next';
import { directionStaff } from '../../../../../utils';
import { Grid } from '@material-ui/core';
import Person from '../../../../../components/Cards/Person';

const Directors = () => {
	const { t } = useTranslation();

	const getStaff = () => {
		return directionStaff.map((director, idx) => (
			<ul>
				<li>
					<Person
						key={idx}
						image={director.image}
						name={t(director.name)}
						label={t(director.label)}
						description={t(director.description)}
						linkedin={director.linkedin}
					/>
				</li>
			</ul>
		));
	};

	return (
		<DirectorsContainer>
			<Grid container justify="center" spacing={2}>
				{getStaff()}
			</Grid>
		</DirectorsContainer>
	);
};

export default Directors;
